import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import HeaderSCI from './HeaderSCI';
import './controlinterno.css';

const Carpetas2022 = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  const controlInternoItems = [
    { label: 'PTACI', to: '#' },
    { label: 'Cronograma de Trabajo', to: '#' },
    { label: 'Reportes Trimestrales', to: '#' },
    { label: 'Informe Anual', to: '#' },
  ];

  const adminRiesgosItems = [
    { label: 'PTAAR', to: '#' },
    { label: 'Cronograma de Trabajo', to: '#' },
    { label: 'Reportes Trimestrales', to: '#' },
    { label: 'Informe Anual', to: '#' },
  ];

  return (
    <>
      <HeaderSCI title="CARPETAS DIGITALES Y EVIDENCIAS" />

      <div className="container" style={{ paddingBottom: '60px', minHeight: '400px' }}>
        
        {/* Header section with Year and Icon */}
        <div className="d-flex justify-content-start align-items-center mt-5 mb-5" style={{ paddingLeft: '5%' }}>
          <div style={{ 
            backgroundColor: '#621132', 
            width: '60px', 
            height: '60px', 
            borderRadius: '50%', 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            color: '#fff',
            fontSize: '1.5rem'
          }}>
            <i className="fa-regular fa-address-card"></i>
          </div>
          <h2 className="ms-3" style={{ color: '#621132', margin: 0, fontWeight: '700', fontFamily: 'Montserrat, sans-serif' }}>
            Año 2022
          </h2>
        </div>

        <div className="row justify-content-center">
          {/* Control Interno */}
          <div className="col-md-5 col-11 mb-5">
            <div className="d-flex justify-content-center w-100">
              <h3 style={{ 
                backgroundColor: '#865100', // Accurate golden-brown 
                color: 'white', 
                borderRadius: '30px', 
                padding: '12px 60px', 
                textAlign: 'center', 
                fontWeight: '700',
                fontFamily: 'Montserrat, sans-serif',
                fontSize: '1.2rem',
                margin: '0',
                width: '100%',
                maxWidth: '400px'
              }}>
                Control Interno
              </h3>
            </div>
            
            <div className="d-flex justify-content-center">
              <ul style={{ 
                listStyleType: 'disc', 
                color: '#621132', 
                paddingLeft: '0', 
                marginTop: '25px',
                fontFamily: 'Montserrat, sans-serif',
                fontSize: '1.05rem',
                fontWeight: '700',
                width: '100%',
                maxWidth: '280px'
              }}>
                {controlInternoItems.map((item, idx) => (
                  <li key={idx} style={{ marginBottom: '8px', marginLeft: '20px' }}>
                    <Link to={item.to} className="carpeta-section-link" style={{ color: '#621132', textDecoration: 'underline', textUnderlineOffset: '4px' }}>
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Administración de Riesgos */}
          <div className="col-md-5 col-11 mb-5 offset-md-1">
            <div className="d-flex justify-content-center w-100">
              <h3 style={{ 
                backgroundColor: '#7A731F', // Accurate olive-green 
                color: 'white', 
                borderRadius: '30px', 
                padding: '12px 60px', 
                textAlign: 'center', 
                fontWeight: '700',
                fontFamily: 'Montserrat, sans-serif',
                fontSize: '1.2rem',
                margin: '0',
                width: '100%',
                maxWidth: '400px'
              }}>
                Administración de Riesgos
              </h3>
            </div>

            <div className="d-flex justify-content-center">
              <ul style={{ 
                listStyleType: 'disc', 
                color: '#621132', 
                paddingLeft: '0', 
                marginTop: '25px',
                fontFamily: 'Montserrat, sans-serif',
                fontSize: '1.05rem',
                fontWeight: '700',
                width: '100%',
                maxWidth: '280px'
              }}>
                {adminRiesgosItems.map((item, idx) => (
                  <li key={idx} style={{ marginBottom: '8px', marginLeft: '20px' }}>
                    <Link to={item.to} className="carpeta-section-link" style={{ color: '#621132', textDecoration: 'underline', textUnderlineOffset: '4px' }}>
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default Carpetas2022;
